import { LoadingArea } from '@consigli/facade';
import { useProject, useProjectId } from '@consigli/hooks';

import { FoldersPageContent } from '@/pages/insight/folders/folders-page-content';

export const FoldersPage = () => {
  const projectId = useProjectId();
  const { project, isLoading: isProjectLoading } = useProject(projectId);

  if (isProjectLoading) {
    return <LoadingArea title="Loading project..." />;
  }

  if (!project || !project.country) {
    throw new Error('Project or country not found');
  }

  return <FoldersPageContent country={project.country} />;
};
